import { Location } from "history";

export const ResourceShareLinkParamKey = "share";

export const makeLinkToShareResource = (location: Location) => {
  const params = new URLSearchParams(location.search);
  params.set(ResourceShareLinkParamKey, "true");

  return {
    ...location,
    search: params.toString()
  } as Location;
};
